export default {
  navigation: {
    home: "Home",
    comfort: "Comfort",
    manage: "Manage",
    profile: "Profile"
  },
  general: {
    title: "Profile",
    logout: "Logout",
    app_version: "App version",
    edit: "Edit",
    view: "View",
    upload: "Upload",
    personal_details: {
      title: "Personal details",
      email: "Email",
      phone: "Phone",
      address: "Address",
      not_available: "Not available",
      guest_since: "Guest since :year",
      guest_since_unknown: "Guest"
    },
    documents: {
      title: "Passport & documents",
      passport: "Passport",
      invoice: "Invoice",
      other_documents: "Documents",
      available: "Available",
      passport_available: "Available",
      not_uploaded: "Not uploaded",
      info: "Documents may be required for check-in verification"
    },
    preferences: {
      title: "Preferences",
      language: "Language",
      language_description: "Choose your preferred language"
    }
  }
};
